import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import {Helmet} from "react-helmet";

export default function GamingLicenseTuvalu() {

    return (
        <main className='main'>
            <Helmet>
                <title>Tuvalu Gaming License | Offshore Licensing & Setup Services</title>
                <meta name="description" content="Secure a Tuvalu gaming license with expert support. Fast, compliant licensing for casinos, sportsbooks, and online gaming platforms." />
                <meta name="keywords" content="
                Tuvalu gaming license, offshore gaming license, online casino license, sportsbook license, iGaming license, gaming license Tuvalu, offshore license setup, online betting license, casino business license, gaming company formation, iGaming startup license, gaming compliance services, offshore gaming jurisdiction, licensing process gaming, gaming license cost, gaming business setup, international gaming license, white label casino license, online gambling license, gaming operator license
                "
                />
            </Helmet>

            <IntroSection
                title="Tuvalu Gaming License | Offshore Advisory"
                description=
                    {
                        `
                    Professional gaming license solutions in Tuvalu provide a fast, flexible, and globally recognized pathway for launching your online gaming or betting business. Offshore Advisory supports operators, startups, and international investors in securing a Tuvalu gaming license with full compliance and efficiency.
                    <br/>
                    With a streamlined regulatory approach, competitive licensing costs, and a supportive offshore framework, Tuvalu has become an attractive jurisdiction for online casinos, sportsbooks, and gaming platforms looking to operate internationally. Our team ensures a seamless licensing process from consultation to ongoing compliance.
                    `
                    }
                buttonText="Request a Tuvalu Gaming Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../../assets/images/Tuvalu Gaming License 3.jpg')}
                imageAlt="Panama Gaming License"
            />


            <section className='section'>
                <div className="container">

                    <h1 className='page-title'>
                        Our Services & Step-by-Step Licensing Process
                    </h1>
                    <p className='page-paragraph'>
                        At Offshore Advisory, we provide complete support to help you secure and operate under a Tuvalu gaming license. From initial consultation to post-license compliance, we simplify every stage.
                    </p>

                    <WhySection
                        title='1. Consultation & Business Planning'
                        subtitle='We begin by understanding your gaming business model and goals. What we do:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Assess your platform type (casino, sportsbook, lottery, etc.)"
                                    },
                                    {
                                        text: "Recommend the best licensing structure"
                                    },
                                    {
                                        text: "Outline requirements, timelines, and costs"
                                    },
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='2. Company Formation & Structuring'
                        subtitle='Before licensing, we ensure your company is properly structured.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Company incorporation in Tuvalu or preferred jurisdiction"
                                    },
                                    {
                                        text: "Structuring ownership for compliance and tax efficiency"
                                    },
                                    {
                                        text: "Preparing required corporate documentation"
                                    },

                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='3. License Application & Documentation'
                        subtitle='We handle the complete application process with authorities. Our services cover:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Preparation and submission of license applications"
                                    },
                                    {
                                        text: "Drafting policies (AML, KYC, Terms & Conditions)"
                                    },
                                    {
                                        text: "Ensuring full regulatory compliance"
                                    },

                                ]
                            }
                        ]}
                    />
                    <WhySection
                        title='4. Payment Processing & Technical Setup'
                        subtitle='We help you become fully operational.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Assistance with payment gateway integration"
                                    },
                                    {
                                        text: "Guidance on gaming software providers"
                                    },
                                    {
                                        text: "Support with platform setup and hosting solutions"
                                    },

                                ]
                            }
                        ]}
                    />
                    <WhySection
                        title='5. Ongoing Compliance & Support'
                        subtitle='After licensing, we ensure your business remains compliant.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Ongoing regulatory and reporting support"
                                    },
                                    {
                                        text: "Assistance with renewals and updates"
                                    },
                                    {
                                        text: "Advisory on international operational requirements"
                                    },

                                ]
                            }
                        ]}
                    />


                    <InfoBlocks
                        blocks={[
                            {
                                title: "Why This Approach Matters",
                                subtitle: "By combining expert advisory with a clear step-by-step process, Offshore Advisory ensures your Tuvalu gaming license is:",
                                items: [
                                    {
                                        title: "Fast & Efficient",
                                        text: "Reduced delays with expert handling"
                                    },
                                    {
                                        title: "Fully Compliant",
                                        text: "Meets all regulatory requirements"
                                    },
                                    {
                                        title: "Transparent",
                                        text: "Clear costs and timelines"
                                    },
                                    {
                                        title: "Scalable ",
                                        text: "Built for long-term growth in global markets"
                                    }
                                ]
                            },

                        ]}
                    />


                    <InfoBlocks
                        blocks={[
                            {
                                title: "Types of Gaming Licenses in Tuvalu",
                                items: [
                                    {
                                        title: "Online Casino License",
                                        text: "Operate slots, table games, and live dealer platforms"
                                    },
                                    {
                                        title: "Sports Betting License",
                                        text: "Run online sportsbooks and betting platforms"
                                    },
                                    {
                                        title: "Lottery License",
                                        text: "Manage digital lottery and raffle systems"
                                    },
                                    {
                                        title: "White Label Solutions",
                                        text: "Launch quickly using pre-built gaming platforms"
                                    }
                                ]
                            }
                        ]}
                    />
                    <DetailsSection
                        title="Who Can Benefit?"
                        items={[
                            {
                                title: "Entrepreneurs & Startups ",
                                text: "Launch gaming platforms quickly"
                            },
                            {
                                title: "Existing Gaming Operators",
                                text: "Expand into new jurisdictions"
                            },
                            {
                                title: "International Investors",
                                text: "Benefit from offshore opportunities"
                            },
                            {
                                title: "Tech Companies",
                                text: "Enter the iGaming industry with ease"
                            },

                        ]}
                        end="Operating under a Tuvalu gaming license gives you a competitive edge in the global online gaming market with flexibility and growth potential."
                    />

                    <Testimonials
                        title="Our Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <FAQList data={faqData} title='FAQs – Tuvalu Gaming License'/>

                    <CTA
                        title="Contact Offshore Advisory Today!"
                        description="Ready to launch your gaming business with a Tuvalu license? Offshore Advisory ensures a fast, compliant, and hassle-free process."
                        buttonText="Book a Tuvalu Gaming License Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can non-residents apply for a Tuvalu gaming license?",
        answer: "Yes, international applicants are eligible, and Offshore Advisory provides full support remotely."
    },
    {
        question: "How long does the licensing process take?",
        answer: "Typically 2–6 weeks, depending on documentation and approval timelines."
    },
    {
        question: "Do I need to visit Tuvalu?",
        answer: "No, most steps can be completed remotely through Offshore Advisory."
    },
    {
        question: "What are the costs involved?",
        answer: "Costs depend on license type and services required, with full transparency provided upfront."
    },
    {
        question: "Can I operate globally with a Tuvalu license?",
        answer: "Yes, subject to compliance with the laws of the countries where you operate."
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory made the entire licensing process straightforward and stress-free. We were operational within weeks.",
        author: "David K.",
        role: "Gaming Operator"
    },
    {
        quote: "Their expertise in offshore licensing helped us expand into international markets quickly and compliantly.",
        author: "Sofia L.",
        role: "iGaming Entrepreneur"
    },

];

